export default "__VITE_PUBLIC_ASSET__ca7b3339__"